import { StyledListItemProps, StyledListProps } from './styles';

/** List */
export default interface ListProps
  extends Omit<StyledListProps, 'color'>,
    React.HTMLAttributes<HTMLUListElement> {}

/** List Item */
interface ListItemCommonProps {
  title?: string | JSX.Element;
  description?: string | JSX.Element;
  action?: JSX.Element;
  icon?: JSX.Element;
  loading?: boolean;
}

type ListItemButtonProps = ListItemCommonProps &
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'title'>;

type ListItemAnchorProps = ListItemCommonProps &
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'title'>;

type ListItemLiProps = ListItemCommonProps &
  Omit<React.LiHTMLAttributes<HTMLLIElement>, 'title'>;

export function isButton(props: ListItemProps): props is ListItemButtonProps {
  return 'onClick' in props;
}

export function isAnchor(props: ListItemProps): props is ListItemAnchorProps {
  return 'href' in props && !('disabled' in props);
}

export type ListItemProps = Omit<StyledListItemProps, 'color'> &
  (ListItemButtonProps | ListItemAnchorProps | ListItemLiProps);
